import { PHONE_QUERY } from 'garaje/utils/is-phone';

// `lg`, the same stop the app shell uses to hide its nav, so `desktop` means the full-nav layout.
const DESKTOP_QUERY = '(min-width: 64em)';
const COARSE_POINTER_QUERY = '(pointer: coarse)';

export type FormFactor = 'phone' | 'tablet' | 'desktop';

function matches(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia(query).matches;
}

/**
 * Which layout the viewport is being served, read at call time so a resize or rotation is reflected.
 * Defaults to `desktop` off-browser, matching the rest of the app's off-browser fallbacks.
 */
export function formFactor(): FormFactor {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'desktop';
  }

  if (matches(PHONE_QUERY)) return 'phone';
  return matches(DESKTOP_QUERY) ? 'desktop' : 'tablet';
}

/** Pairs with `formFactor` to tell a real touch device from a narrowed desktop window. */
export function hasTouchInput(): boolean {
  return matches(COARSE_POINTER_QUERY);
}

/**
 * Viewport properties for an analytics event, as one object so every emitter of a given event sends
 * the same shape. Spread it at each `trackEvent` call: a screen that emits the same event from more
 * than one place has to stamp all of them, or the property reads as partly populated for that screen.
 */
export function viewportProperties(): { form_factor: FormFactor; touch: boolean } {
  return { form_factor: formFactor(), touch: hasTouchInput() };
}
